import { ExternalLink, Rocket, Award, Users, PlayCircle, Star, Crown, Medal, Gem, Target } from 'lucide-react';

export default function AirdropInfo() {
  return (
    <div className="py-8 w-full relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="font-tokyo text-3xl font-bold bg-gradient-to-r from-quantum-primary to-quantum-secondary bg-clip-text text-transparent mb-2">
            <Gem className="inline w-8 h-8 mr-2" /> Quantum Genesis Airdrop
          </h2>
          <p className="text-lg text-quantum-light/80 mb-4">
            <Rocket className="inline w-5 h-5 mr-1" /> The Official QGEN Airdrop Campaign is LIVE!
          </p>
          <p className="text-sm text-quantum-light/70 max-w-3xl mx-auto">
            Join the Quantum Genesis airdrop and earn your share of <span className="text-quantum-primary font-semibold">30,000,000 QGEN tokens</span> (3% of total supply) — distributed to our most active and early supporters.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8">
          {/* How to Join */}
          <div className="quantum-card p-6">
            <h3 className="text-xl font-semibold text-quantum-light mb-4 flex items-center">
              <PlayCircle className="w-5 h-5 mr-2 text-quantum-primary" />
               How to Join
            </h3>
            <div className="space-y-3 mb-6">
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-quantum-primary rounded-full flex items-center justify-center text-xs font-bold text-quantum-dark">
                  1
                </div>
                <p className="text-sm text-quantum-light/80">
                  Join our Telegram bot <span className="text-quantum-primary font-semibold">@QgenairdropBot</span>
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-quantum-primary rounded-full flex items-center justify-center text-xs font-bold text-quantum-dark">
                  2
                </div>
                <p className="text-sm text-quantum-light/80">
                  Complete simple tasks (follow, invite, verify)
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-quantum-primary rounded-full flex items-center justify-center text-xs font-bold text-quantum-dark">
                  3
                </div>
                <p className="text-sm text-quantum-light/80">
                  Earn points and climb the leaderboard
                </p>
              </div>
              <div className="flex items-start space-x-3">
                <div className="flex-shrink-0 w-6 h-6 bg-quantum-primary rounded-full flex items-center justify-center text-xs font-bold text-quantum-dark">
                  4
                </div>
                <p className="text-sm text-quantum-light/80">
                  Get rewarded after the campaign ends!
                </p>
              </div>
            </div>

            {/* Social Media Buttons */}
            <div className="flex flex-col gap-3 mb-4">
              <a
                href="https://t.me/QgenairdropBot"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button flex items-center justify-center space-x-2 px-4 py-2 text-sm transition-all duration-300"
              >
                <Target className="w-4 h-4" />
                <span>Start Airdrop Bot</span>
                <ExternalLink className="w-4 h-4" />
              </a>

              <a
                href="https://discord.gg/zxENEqvrVN"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button flex items-center justify-center space-x-2 px-4 py-2 text-sm transition-all duration-300"
              >
                <Users className="w-4 h-4" />
                <span>Join Discord Community</span>
                <ExternalLink className="w-4 h-4" />
              </a>
              
              <a
                href="https://x.com/QgenToken"
                target="_blank"
                rel="noopener noreferrer"
                className="quantum-button flex items-center justify-center space-x-2 px-4 py-2 text-sm transition-all duration-300"
              >
                <Star className="w-4 h-4" />
                <span>Follow on X (Twitter)</span>
                <ExternalLink className="w-4 h-4" />
              </a>
            </div>
          </div>

          {/* Rewards Breakdown */}
          <div className="quantum-card p-6">
            <h3 className="text-xl font-semibold text-quantum-light mb-4 flex items-center">
              <Award className="w-5 h-5 mr-2 text-quantum-primary" />
              Rewards Breakdown
            </h3>
            <div className="space-y-3">
              <div className="flex items-center justify-between p-3 bg-gradient-to-r from-yellow-500/10 to-yellow-600/5 rounded-lg border border-yellow-500/20">
                <div className="flex items-center space-x-2">
                  <Crown className="w-5 h-5 text-yellow-400" />
                  <span className="text-sm text-quantum-light">Top 1–10</span>
                </div>
                <span className="text-sm font-semibold text-yellow-400">6M QGEN</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-400/10 to-gray-500/5 rounded-lg border border-gray-400/20">
                <div className="flex items-center space-x-2">
                  <Medal className="w-5 h-5 text-gray-300" />
                  <span className="text-sm text-quantum-light">Rank 11–50</span>
                </div>
                <span className="text-sm font-semibold text-gray-300">8M QGEN</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gradient-to-r from-amber-600/10 to-amber-700/5 rounded-lg border border-amber-600/20">
                <div className="flex items-center space-x-2">
                  <Award className="w-5 h-5 text-amber-400" />
                  <span className="text-sm text-quantum-light">Rank 51–150</span>
                </div>
                <span className="text-sm font-semibold text-amber-400">7M QGEN</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gradient-to-r from-quantum-primary/10 to-quantum-secondary/5 rounded-lg border border-quantum-primary/20">
                <div className="flex items-center space-x-2">
                  <Star className="w-4 h-4 text-quantum-primary" />
                  <span className="text-sm text-quantum-light">Rank 151–500</span>
                </div>
                <span className="text-sm font-semibold text-quantum-primary">5M QGEN</span>
              </div>
              <div className="flex items-center justify-between p-3 bg-gradient-to-r from-quantum-secondary/10 to-quantum-primary/5 rounded-lg border border-quantum-secondary/20">
                <div className="flex items-center space-x-2">
                  <Users className="w-4 h-4 text-quantum-secondary" />
                  <span className="text-sm text-quantum-light">All verified users (501+)</span>
                </div>
                <span className="text-sm font-semibold text-quantum-secondary">4M QGEN shared</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
} 